// React Basic and Bootstrap
import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Input,
  Label,
} from "reactstrap";
import classnames from "classnames";
import FeatherIcon from "feather-icons-react";

//Import Components
import SectionTitle from "../../components/Shared/SectionTitle";

class Price extends Component {
  phone1 = "";
  sended = false;
  constructor(props) {
    super(props);
    this.state = {
      pricings1: [
        {
          id: 1,
          title: "Минимум",
          price: 1950,
          duration: "мес",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          feedback: false,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления в телеграм" },
          ],
        },
        {
          id: 2,
          title: "Оптимум",
          price: 3350,
          duration: "мес",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          feedback: false,
          isActive: true,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления телеграм/смс/whatsapp" },
            { title: "Интеграции (iiko, R-Keeper и д.р.)" }
          ],
        },
        {
          id: 3,
          title: "Максимум",
          price: 4400,
          duration: "мес",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          feedback: false,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления телеграм/смс/whatsapp" },
            { title: "Интеграции (iiko, R-Keeper и д.р.)" },
            { title: "Интеграция с «МойСклад»" },
            { title: "Интеграция с VКонтакте" },
          ],
        },
        {
          id: 4,
          title: "Консультация по подключению",
          price: "0₽",
          duration: "",
          buttonText: "",
          btnLink: "",
          feedback: true,
          features: [
            { title: "Если у вас уже есть рабочая схема" },
            { title: "Но чего-то не хватает" },
            { title: "Подскажем и поможем!" },
          ],
        },
      ],
      pricings2: [
        {
          id: 1,
          title: "Минимум",
          price: 21060,
          duration: "год",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          feedback: false,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления в телеграм" },
          ],
        },
        {
          id: 2,
          title: "Оптимум",
          price: 40200,
          duration: "год",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          isActive: true,
          feedback: false,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления телеграм/смс/whatsapp" },
            { title: "Интеграции (iiko, R-Keeper и д.р.)" }
          ],
        },
        {
          id: 3,
          title: "Максимум",
          price: 47520,
          duration: "год",
          buttonText: "Купить сейчас",
          btnLink: "#consultation",
          feedback: false,
          features: [
            { title: "Интернет-магазин" },
            { title: "Онлайн-платежи" },
            { title: "Уведомления телеграм/смс/whatsapp" },
            { title: "Интеграции (iiko, R-Keeper и д.р.)" },
            { title: "Интеграция с «МойСклад»" },
            { title: "Интеграция с VКонтакте" },
          ],
        },
        {
          id: 4,
          title: "Консультация по подключению",
          price: "0₽",
          duration: "",
          buttonText: "",
          btnLink: "",
          feedback: true,
          features: [
            { title: "Если у вас уже есть рабочая схема" },
            { title: "Но чего-то не хватает" },
            { title: "Подскажем и поможем!" },
          ],
        },
      ],
      activeTab: "1",
      activeIndex1: 1,
      activeIndex2: 5,
    };
    this.toggleTab.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        phone1: this.phone1,
      });
    }
  }

  phoneChanged(e) {
    this.phone1 = e.target.value;
  }

  sendPhone(phone) {
    if (phone != "") {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone, from: "soft.kit-app.ru", comment: "Нужна консультация за 0 рублей" })
      };
      fetch("/api/v1/sendFeedback/", requestOptions)
        .then((result)=> {
          this.setState({
            sended: true,
          });
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <section className="section">
          <Container>
            {/* section title */}
            <SectionTitle
              title="Цены"
              desc="Стоимость наших услуг"
            />

            <Row className="align-items-center">
              <Col xs="12" className="mt-4 pt-2">
                <div className="text-center">
                  <Nav
                    pills
                    justified
                    className="rounded-pill justify-content-center d-inline-block border py-1 px-2"
                  >
                    <NavItem className="d-inline-block">
                      <NavLink
                        className={classnames(
                          { active: this.state.activeTab === "1" },
                          "px-3",
                          "rounded-pill",
                          "monthly"
                        )}
                        onClick={() => {
                          this.toggleTab("1");
                        }}
                      >
                        Ежемесячно
                      </NavLink>
                    </NavItem>
                    <NavItem className="d-inline-block">
                      <NavLink
                        className={classnames(
                          { active: this.state.activeTab === "2" },
                          "px-3",
                          "rounded-pill",
                          "yearly"
                        )}
                        onClick={() => {
                          this.toggleTab("2");
                        }}
                      >
                        Ежегодно{" "}
                        <span className="badge rounded-pill bg-success">10%</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      {this.state.pricings1.map((pricing, key) => (
                        <Col
                          lg={3}
                          key={key}
                          md={6}
                          xs={12}
                          className="mt-4 pt-2"
                        >
                          <Card
                            className={
                              pricing.isActive
                                ? "pricing-rates bg-white rounded border-0 shadow"
                                : "pricing-rates bg-light rounded border-0 shadow"
                            }
                          >
                            <CardBody className="py-5">
                              <h6
                                className={
                                  pricing.isActive
                                    ? "title text-uppercase mb-4 text-primary"
                                    : "title text-uppercase mb-4"
                                }
                              >
                                {pricing.title}
                              </h6>
                              <div className="d-flex mb-4">
                                <span className="h4 mb-0 mt-2"></span>
                                <span className="price h1 mb-0">
                                  {pricing.price}
                                </span>
                                <span className="h4 align-self-end mb-1">
                                  {pricing.duration}
                                </span>
                              </div>
                              { (pricing.feedback) ? ("") : ("Вы получите:") }
                              <ul className="list-unstyled mb-0 ps-0">
                                {pricing.features.map((feature, key) => (
                                  <li key={key} className="text-muted mb-0">
                                    <span className="text-primary h5 me-2">
                                      <i className="uil uil-check-circle align-middle"></i>
                                    </span>
                                    {feature.title}
                                  </li>
                                ))}
                              </ul>
                              { (pricing.btnLink != '') ? 
                                (<a href={pricing.btnLink} className="btn btn-primary mt-4">
                                    {pricing.buttonText}
                                  </a>) : null }
                              { (pricing.feedback) ? (
                                <Row>
                                  <Col lg="12">
                                    <div className={ this.props.isLight ? "foot-subscribe mb-3 foot-white" : "foot-subscribe mb-3" }>
                                      <Label className={this.props.isLight ? "form-label text-muted" : "form-label"}>
                                        Введите свой номер{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <div className="form-icon position-relative">
                                        <FeatherIcon icon="phone" className="fea icon-sm icons"/>
                                      </div>
                                      <Input 
                                        type="phone" 
                                        name="phone" 
                                        id="emailsubscribe" 
                                        className={ 
                                          false
                                            ? "ps-5 rounded bg-light border" 
                                            : "ps-5 rounded" 
                                        }
                                        style={{"color":"black"}}
                                        placeholder="Ваш телефон : "
                                        required
                                        onKeyUp={(e)=>{this.phoneChanged(e);}}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg="12">
                                    <div className="d-grid">
                                      { this.state.sended ? ("Отправлено, мы с Вам скоро свяжемся!") : (
                                        <button class="btn btn-pills btn-primary" onClick={()=>{this.sendPhone(this.phone1)}}>Отправить</button>
                                      ) }
                                    </div>
                                  </Col>
                                </Row>
                              ) : null }
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </TabPane>

                  <TabPane tabId="2">
                    <Row>
                      {this.state.pricings2.map((pricing, key) => (
                        <Col
                          lg={3}
                          key={key}
                          md={6}
                          xs={12}
                          className="mt-4 pt-2"
                        >
                          <div
                            className={
                              pricing.isActive
                                ? "pricing-rates bg-white py-5 p-4 rounded"
                                : "pricing-rates bg-light py-5 p-4 rounded"
                            }
                          >
                            <h6
                              className={
                                pricing.isActive
                                  ? "title text-uppercase fw-bold mb-4 text-primary"
                                  : "title text-uppercase fw-bold mb-4"
                              }
                            >
                              {pricing.title}
                            </h6>
                            <div className="d-flex mb-4">
                              <span className="h4 mb-0 mt-2"></span>
                              <span className="price h1 mb-0">
                                {pricing.price}
                              </span>
                              <span className="h4 align-self-end mb-1">
                                {pricing.duration}
                              </span>
                            </div>

                            { (pricing.feedback) ? ("") : ("Вы получите:") }
                            <ul className="list-unstyled mb-0 ps-0">
                              {pricing.features.map((feature, key) => (
                                <li key={key} className="text-muted mb-0">
                                  <span className="text-primary h5 me-2">
                                    <i className="uil uil-check-circle align-middle"></i>
                                  </span>
                                  {feature.title}
                                </li>
                              ))}
                            </ul>
                            { (pricing.btnLink != '') ? 
                              (<a href={pricing.btnLink} className="btn btn-primary mt-4">
                                  {pricing.buttonText}
                                </a>) : null }
                            { (pricing.feedback) ? (
                              <Row>
                                <Col lg="12">
                                  <div className={ this.props.isLight ? "foot-subscribe mb-3 foot-white" : "foot-subscribe mb-3" }>
                                    <Label className={this.props.isLight ? "form-label text-muted" : "form-label"}>
                                      Введите свой номер{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="form-icon position-relative">
                                      <FeatherIcon icon="phone" className="fea icon-sm icons"/>
                                    </div>
                                    <Input 
                                      type="phone" 
                                      name="phone" 
                                      id="emailsubscribe" 
                                      value={this.state.phone1}
                                      className={ 
                                        false
                                          ? "ps-5 rounded bg-light border" 
                                          : "ps-5 rounded" 
                                      }
                                      style={{"color":"black"}}
                                      placeholder="Ваш телефон : "
                                      required
                                      onKeyUp={(e)=>{this.phoneChanged(e);}}
                                    />
                                  </div>
                                </Col>
                                <Col lg="12">
                                  <div className="d-grid">
                                    { this.state.sended ? ("Отправлено, мы с Вам скоро свяжемся!") : (
                                      <button class="btn btn-pills btn-primary" onClick={()=>{this.sendPhone(this.phone1)}}>Отправить</button>
                                    ) }
                                  </div>
                                </Col>
                              </Row>
                            ) : null }
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Container>
        </section>
        <div className="position-relative">
          <div className="shape overflow-hidden text-light">
            <svg
              viewBox="0 0 2880 250"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M720 125L2160 0H2880V250H0V125H720Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Price;
